export * from './tabs-content'
